import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Tag} from 'primereact/tag';
import {ProgressBar} from 'primereact/progressbar';

const CustomerOrderProjectListComponent = ({projectId, t}) => {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + `/api/v2/customer-order?item_per_page=200&sort=order_date&direction=desc&search[project][operator]=%3D&search[project][value]=${projectId}`, {headers: {
      Authorization: 'Bearer ' + localStorage.getItem('userToken'),
      'App-Network': localStorage.getItem('networkId'),
    }}).then(response => setItems(response.data?.data?.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
      .finally(() => setLoading(false));
  }, [projectId]);

  return <div>{loading && <ProgressBar mode="indeterminate" style={{height: 4}}/>}
    <DataTable value={items} responsiveLayout="scroll" emptyMessage={t('customerOrderNoProjectOrders')}>
      <Column field="order_number" header={t('customerOrderInternalNumber')}/>
      <Column field="external_number" header={t('customerOrderExternalNumber')}/>
      <Column field="order_date" header={t('customerOrderDate')} body={row => row.order_date ? new Intl.DateTimeFormat('hu-HU').format(new Date(row.order_date.replace(' ', 'T'))) : '—'}/>
      <Column field="status" header={t('columnStatus2')} body={row => <Tag value={t('customerOrderStatus.' + row.status, {defaultValue: row.status})}/>}/>
      <Column body={row => <Button icon="pi pi-eye" className="p-button-sm" onClick={() => history.push('/sales/customer-order/read/' + row.id)}/>}/>
    </DataTable>
  </div>;
};

export default withTranslation('common')(CustomerOrderProjectListComponent);
